/**
 * Empório Saibai — quick add inline: estado visual e preço por variante.
 * Build 2026-08-08.
 */
(() => {
  'use strict';
  if (window.__saibaiQuickAddInlineInit) return;
  window.__saibaiQuickAddInlineInit = true;

  const update = (select) => {
    if (!(select instanceof HTMLSelectElement)) return;
    const option = select.selectedOptions[0];
    const price = option?.dataset.price;
    if (!price) return;

    const card = select.closest('.product-card-wrapper, .saibai-prod__card');
    if (!card) return;
    card.classList.add('has-saibai-variants');

    const compare = option.dataset.comparePrice || '';
    const onSale = option.dataset.onSale === 'true';

    const homePrice = card.querySelector('.saibai-prod__amount');
    const homeCompare = card.querySelector('.saibai-prod__compare');
    if (homePrice) homePrice.textContent = price;
    if (homeCompare) {
      homeCompare.textContent = compare;
      homeCompare.hidden = !onSale;
    }

    const priceRoot = card.querySelector('.price');
    if (!priceRoot) return;
    priceRoot.classList.toggle('price--on-sale', onSale);

    const regular = priceRoot.querySelector('.price__regular .price-item--regular');
    const sale = priceRoot.querySelector('.price__sale .price-item--sale.price-item--last');
    const compareElement = priceRoot.querySelector(
      '.price__sale .price-item--regular, .price__sale s'
    );

    if (regular) regular.textContent = price;
    if (sale) sale.textContent = price;
    if (compareElement && compare) compareElement.textContent = compare;
  };

  const init = (root = document) => {
    const scope = root?.querySelectorAll ? root : document;
    scope.querySelectorAll('.saibai-quick-add__variant-select').forEach(update);
  };

  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLSelectElement &&
        event.target.matches('.saibai-quick-add__variant-select')) {
      update(event.target);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('productsLoaded', () => init());
  document.addEventListener('recommendations:loaded', () => init());
})();
